import { useEffect } from 'react';

export default function AboutPage() {
  useEffect(() => {
    document.title = "About Us | Yappyli";
  }, []);

  return (
    <section className="pt-32 pb-20 px-6 max-w-4xl mx-auto">
      <span className="bg-[#EEECFF] text-[#7367ff] px-4 py-1 rounded-full font-bold text-xs uppercase tracking-widest">Our Story</span>
      <h1 className="text-5xl font-extrabold text-[#0F172A] mt-6 mb-8">A Passion Project for <span className="italic underline decoration-[#7367ff] underline-offset-4">Privacy.</span></h1>
      
      <div className="prose prose-lg text-[#64748B] space-y-6">
        <p>Yappyli didn't start in a boardroom; it started with a simple question: <strong>Why is staying connected so invasive?</strong></p>
        <p>We view Yappyli as more than just an app—it's an open-source experiment in digital sovereignty. Built by a small group of developers who were tired of "free" services that actually cost you your data, Yappyli is designed to be a permanent utility for the public good.</p>
        
        <div className="grid md:grid-cols-2 gap-6 my-12">
          <div className="p-6 bg-[#FAFAFC] rounded-2xl border border-[#E2E8F0]">
            <h3 className="font-extrabold text-[#0F172A] text-xl mb-2">100% Free</h3>
            <p className="text-sm">No subscriptions, no "pro" tiers, and no ads. Yappyli is funded by the community, for the community.</p>
          </div>
          <div className="p-6 bg-[#FAFAFC] rounded-2xl border border-[#E2E8F0]">
            <h3 className="font-extrabold text-[#0F172A] text-xl mb-2">Open Hearted</h3>
            <p className="text-sm">Our code is open for inspection. We believe transparency is the only way to build true digital trust.</p>
          </div>
        </div>

        <h2 className="text-3xl font-extrabold text-[#0F172A]">The Human Element</h2>
        <p>We prioritize "yapping" over "scrolling." Our interface is designed to keep you focused on your friends, not on a feed designed to keep you addicted. It's simple, it's fast, and it belongs to you.</p>
      </div>
    </section>
  );
}